import React, { useState, useRef } from 'react';
import { Upload, X, FileText } from 'lucide-react';
import { cn } from '../../utils/cn';

export function FileInput({
  accept,
  multiple = false,
  onChange,
  className,
  hint = 'Glisse un fichier ici ou clique pour choisir',
  ...rest
}) {
  const ref = useRef(null);
  const [files, setFiles] = useState([]);
  const [over, setOver] = useState(false);

  const update = (list) => {
    const arr = Array.from(list || []);
    setFiles(arr);
    onChange?.(arr);
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); update(e.dataTransfer.files); }}
      onClick={() => ref.current?.click()}
      className={cn(
        'w-full border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors',
        over ? 'border-ink bg-bg-2' : 'border-border bg-surface hover:bg-bg-2',
        className,
      )}
    >
      <input ref={ref} type="file" accept={accept} multiple={multiple} className="sr-only" onChange={(e) => update(e.target.files)} {...rest} />
      <Upload className="w-6 h-6 mx-auto text-mute mb-2" strokeWidth={1.6} />
      <div className="text-sm font-medium text-text">{hint}</div>
      <div className="text-xs text-mute mt-1">{accept && `Formats : ${accept}`}</div>

      {files.length > 0 && (
        <ul className="mt-4 space-y-1 text-left">
          {files.map((f) => (
            <li key={f.name} className="flex items-center gap-2 text-sm bg-bg-2 px-2.5 py-1.5 rounded-md">
              <FileText className="w-4 h-4 text-mute shrink-0" strokeWidth={1.8} />
              <span className="flex-1 truncate">{f.name}</span>
              <span className="font-mono text-xs text-mute">{(f.size / 1024).toFixed(1)} ko</span>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); update(files.filter(x => x !== f)); }}
                className="text-mute hover:text-danger p-0.5 rounded"
                aria-label="Retirer"
              >
                <X className="w-3.5 h-3.5" strokeWidth={2} />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default FileInput;
